import React from 'react';
import AdminNavigation from './navigation/AdminNavigation';
import StandardNavigation from './navigation/StandardNavigation';
import { useNavigation } from '../hooks/useNavigation';

const SidebarNavigation: React.FC = () => {
  const { isAdmin, currentPath } = useNavigation();

  // Nota: existía una rama isMedicalBusiness → <MedicalNavigation>, pero ese componente
  // no existe en el repo (la vertical médica vive en la agenda dental) y lealify-base
  // manda businessType 'default' fijo — era una bomba latente (crash si algún tenant
  // llegara como 'medical'). Retirada 2026-07-04.
  return (
    <div className="space-y-1 bg-surface">
      {isAdmin ? (
        <AdminNavigation
          currentPath={currentPath}
        />
      ) : (
        <StandardNavigation
          currentPath={currentPath}
        />
      )}
    </div>
  );
};

export default SidebarNavigation;